import { range } from "lodash"
import { ButtonContainer, Buttons } from "../../../generic-sprites/Buttons"
import { Rectangle } from "../../../generic-sprites/Shape"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { MakeAVideoState } from "../MakeAVideoState"
import { MakeAVideoStore } from "../MakeAVideoStore"
import { MakeVideoLayoutTypes, MakeVideoSprite, MakeVideoSpriteContainer } from "../MakeVideoTypes"
import { MakeVideoLayoutTypeContainer } from "./MakeVideoLayoutTypeContainer"

export class MakeVideoBackgroundSelectContainer implements MakeVideoSprite, MakeVideoSpriteContainer {
    active: boolean
    private readonly backgrounds: Array<MakeVideoBackgroundImage>
    private layouts: Array<MakeVideoLayoutTypeContainer>

    constructor(
        game: Phaser.Game,
        group: Phaser.Group,
        x: number,
        y: number,
        private nextButton: ButtonContainer,
        private edit: boolean,
        debug: boolean,
        moveToStep: () => void
    ) {
        const indices: Array<number> = range(1, 7)
        let currentX = x
        let currentY = y
        this.layouts = []
        this.backgrounds = indices.map(index => {
            const background = new MakeVideoBackgroundImage(game, index, 0.5, group, currentX, currentY, debug, this.onBackgroundClick)
            if (index === 3) {
                currentY += background.sprite.height + Scale.y(0.05)
                currentX = x
            } else {
                currentX += background.sprite.width + Scale.x(0.05)
            }
            this.layouts.push(new MakeVideoLayoutTypeContainer(game, group, background, 20, MakeVideoLayoutTypes.LAYOUT_1))
            return background
        })

        if (this.edit) {
            const savedBackground = MakeAVideoStore.instance.background
            const background = this.backgrounds[savedBackground]
            if (background != null) {
                background.selected = true
            }
        }
        this.active = true

        MakeAVideoState.debugPanel.setSkip(() => {
            game.sound.stopAll()
            MakeAVideoStore.instance.background = 2
            moveToStep()
        })
    }

    destroy = () => {
        this.backgrounds.forEach(background => background.destroy())
        this.layouts.forEach(layout => layout.destroy())
        this.active = false
    }

    disableAll = () => this.backgrounds.forEach(background => background.disable())

    enableAll = () => {
        this.backgrounds.forEach(background => background.enable())
        if (this.edit) {
            this.nextButton.enable()
        }
    }

    private onBackgroundClick = (name: string) => {
        this.backgrounds.filter(background => background.backgroundName !== name).forEach(background => background.selected = false)
        this.nextButton.enable()
    }
}

export class MakeVideoBackgroundImage implements MakeVideoSprite {
    active: boolean
    backgroundName: string
    sprite: Phaser.Sprite
    private outline: Rectangle

    private static readonly backgroundName = (background: number): string => `background-${background}.png`

    constructor(
        game: Phaser.Game,
        public background: number,
        scale: number,
        group: Phaser.Group,
        x: number,
        y: number,
        debug: boolean,
        private onClick?: (str: string) => void,
    ) {
        this.backgroundName = MakeVideoBackgroundImage.backgroundName(background)
        this.sprite = Sprites.add(game, this.backgroundName, {scale, debug, group, x, y})
        this.outline = new Rectangle(game, this.sprite.x, this.sprite.y, this.sprite.width, this.sprite.height, {
            lineColor: Phaser.Color.RED,
            lineWidth: 5,
            group
        })

        if (onClick) {
            Buttons.makeSpriteButton(this.sprite, this.onBackgroundClick)
        }

        this.selected = false
        this.active = true
    }

    set selected(selected: boolean) {
        this.outline.graphics.visible = selected
    }

    enable = () => Buttons.makeSpriteButton(this.sprite, this.onBackgroundClick)

    disable = () => Buttons.undoSpriteButton(this.sprite)

    destroy = () => {
        this.sprite.destroy(true)
        this.outline.destroy()
        this.active = false
    }

    private onBackgroundClick = () => {
        this.selected = true
        this.onClick(this.backgroundName)
        MakeAVideoStore.instance.background = this.background
    }
}
